export enum TagActiveLabel {
	Active = 'Ativo',
	Inactive = 'Inativo',
	Recused = 'Recusado',
}
